import React, { FC } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { LoadingButton } from '@mui/lab'

interface IDialog {
  open: boolean
  handleClose: () => void
  handleAgree: () => void
  message?: string | React.ReactNode
  title?: string
  loading?: boolean
  agreeText?: string
  closeText?: string
  showClose?: boolean
  disableGutters?: boolean
  fullWidth?: boolean
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const DialogQuestion: FC<IDialog> = ({
  open,
  handleClose,
  message,
  handleAgree,
  title,
  loading,
  showClose = true,
  agreeText = 'Да',
  closeText = 'Нет',
  disableGutters,
  ...dialogProps
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      {...dialogProps}
    >
      {title ? <DialogTitle>{title}</DialogTitle> : null}
      {message ? (
        <DialogContent sx={{ padding: disableGutters ? 0 : '20px 24px' }}>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
      ) : null}
      <DialogActions>
        {showClose && (
          <Button
            onClick={handleClose}
            color={'error'}
          >
            {closeText}
          </Button>
        )}
        <LoadingButton
          onClick={handleAgree}
          autoFocus
          loading={loading}
          variant='outlined'
        >
          {agreeText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default DialogQuestion
